import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { CredentialTypeController, CustomCodeValuesController_ } from '../../models/master/mastermodel';


@Pipe({
  name: 'CredentialTypeFilter'
})

@Injectable()
export class CredentialTypePipe implements PipeTransform {

  transform(value: CredentialTypeController[], filter: string): CredentialTypeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CredentialTypeController) =>
      app.Name != null && app.Name.toLocaleLowerCase().indexOf(filter) != -1

      || app.ShortName != null && app.ShortName.toLocaleLowerCase().indexOf(filter) != -1
      || app.GROUPLongValue != null && app.GROUPLongValue.toLocaleLowerCase().indexOf(filter) != -1
      || app.RenewalTypeLongValue != null && app.RenewalTypeLongValue.toLocaleLowerCase().indexOf(filter) != -1
      || app.Speciality != null && app.Speciality.toLocaleLowerCase().indexOf(filter) != -1
      || app.RenewalDurationDays != null && app.RenewalDurationDays.toString().indexOf(filter) != -1

    ) : value;
  }

}



@Pipe({
  name: 'CataloguePipe'
})

@Injectable()
export class CataloguePipe implements PipeTransform {

  transform(value: CustomCodeValuesController_[], filter: string): CustomCodeValuesController_[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CustomCodeValuesController_) =>
      app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1
       

    ) : value;
  }

}
